import { useConfig } from '~components/hooks';
import { useTranslation } from 'react-i18next';
import { SyntheticEvent } from 'react';
import { useYaMetrica } from '~frontend/provider/yametrica';

import IconVk from '../scss/images/login-btn-vk-icon.svg?react';
import IconGoogle from '../scss/images/login-btn-google-icon.svg?react';

export const AuthBlock = ({ authSocial = false }) => {
  const yametrica = useYaMetrica();
  const getConfig = useConfig();
  const { t } = useTranslation();

  const reachGoal = (event: SyntheticEvent<HTMLElement>) => {
    yametrica.reachGoal(event.currentTarget.getAttribute('data-reachgoal'));
  };

  return (
    <div className="login-btns ">
      <a
        className="login-btns__item login-btns__item--steam"
        href="/auth/steam"
        data-reachgoal="steam_auth"
        onClick={reachGoal}
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 18.0309V23.9069L9.09015 26.9314V27.0012C9.09328 28.5914 9.74877 30.1151 10.9127 31.2394C12.0767 32.3637 13.6542 32.9974 15.3001 33C16.9471 33 18.5268 32.3674 19.6914 31.2422C20.856 30.117 21.5103 28.5911 21.5103 26.9998L27.7202 23.0001C29.9153 22.9971 32.0192 22.1532 33.5713 20.6536C35.1235 19.154 35.9969 17.1201 36 14.9994C35.9973 12.8785 35.1243 10.8462 33.5721 9.34651C32.0199 7.84681 29.9154 7.00265 27.7202 7C25.5251 7.00265 23.4206 7.84681 21.8684 9.34651C20.3162 10.8462 19.4429 12.8785 19.4401 14.9994L15.3001 20.9996C14.4482 20.9993 13.6055 21.169 12.8245 21.4976C12.0435 21.8262 11.3412 22.3066 10.7611 22.9094L0 18.0309ZM18.2276 29.829C17.4515 30.5788 16.3989 31.0005 15.3013 31.0009C14.318 30.9998 13.3672 30.6619 12.618 30.0466C11.8687 29.4313 11.3699 28.5791 11.2105 27.6415L14.0197 28.5734C14.3842 28.8517 14.8354 29.0039 15.3001 29.0031C15.8491 29.0031 16.3756 28.7922 16.7638 28.4172C17.152 28.0421 17.3703 27.533 17.3703 27.0026C17.3703 26.4721 17.152 25.963 16.7638 25.588C16.3756 25.2129 15.8491 25.002 15.3001 25.002V24.9713L12.7866 23.8288C13.5068 23.2923 14.3906 23.0013 15.3001 23.0015C16.3981 23.0015 17.4512 23.4232 18.2276 24.1734C19.004 24.9235 19.4401 25.9403 19.4401 27.0012C19.4401 28.062 19.004 29.0789 18.2276 29.829ZM23.3315 19.2418C22.1674 18.1171 21.5127 16.5913 21.5103 15.0008C21.5123 13.41 22.1669 11.8859 23.3311 10.7611C24.4953 9.63632 26.0739 9.00382 27.7202 9.00193C29.3665 9.0042 30.9446 9.63641 32.1087 10.7611C33.2727 11.8858 33.9278 13.4102 33.9301 15.0008C33.9278 16.5913 33.2727 18.1171 32.1087 19.2418C30.9446 20.3665 29.3665 20.9987 27.7202 21.001C26.074 20.9987 24.4956 20.3665 23.3315 19.2418ZM24.7927 12.1729C24.0163 12.9231 23.5802 13.9399 23.5802 15.0008C23.5802 16.0616 24.0163 17.0798 24.7927 17.83C25.5691 18.5801 26.6222 19.0018 27.7202 19.0018C28.8182 19.0018 29.871 18.5801 30.6474 17.83C31.4238 17.0798 31.8603 16.0616 31.8603 15.0008C31.8603 13.9399 31.4238 12.9231 30.6474 12.1729C29.871 11.4228 28.8182 11.0011 27.7202 11.0011C26.6222 11.0011 25.5691 11.4228 24.7927 12.1729Z"
            fill="#411E02"
          ></path>
        </svg>
        <span>{t('Login')}</span>
      </a>
      {getConfig?.hostname !== 'cscase.com' && (
        <a
          className="login-btns__item login-btns__item--vk"
          href="/auth/vk"
          onClick={reachGoal}
          data-reachgoal="vk_auth"
        >
          <IconVk />
        </a>
      )}
      <a
        className="login-btns__item login-btns__item--fb"
        href="/auth/fb"
        onClick={reachGoal}
        data-reachgoal="fb_auth"
      >
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 40H26V26H31L33 20H26V16C26.0018 13.9844 27.3584 13.9917 28.7314 13.9991C28.821 13.9996 28.9106 14.0001 29 14H31V8H26C24.2104 8.00212 22.2654 8.73459 21 10C19.9234 11.0766 19.9564 12.6451 19.9889 14.1912C19.9946 14.4624 20.0003 14.7329 20 15V20H15V26H20V40Z"
            fill="white"
          ></path>
        </svg> 
      </a>

      {getConfig?.hostname === 'cscase.com' && (
        <a
          className="login-btns__item login-btns__item--google"
          href="/auth/google"
          onClick={reachGoal}
          data-reachgoal="g_auth"
        >
          <IconGoogle />
        </a>
      )}
    </div>
  )
  // <div className="open-cases-btns">
  //   <a
  //     className="advantages-sign-in-steam"
  //     href="/auth/steam"
  //     onClick={reachGoal}
  //     data-reachgoal="steam_auth"
  //   >
  //     <div className="small-text">{t('Sign in through')}</div>
  //     <div className="text">Steam</div>
  //     <div className="top"></div>
  //     <div className="bot-1"></div>
  //     <div className="bot-2"></div>
  //   </a>

  //   {authSocial ? (
  //     <div className="authorization-social">
  //       {getConfig?.hostname !== 'cscase.com' && (
  //         <a
  //           className="vk"
  //           href="/auth/vk"
  //           onClick={reachGoal}
  //           data-reachgoal="vk_auth"
  //         />
  //       )}
  //       {getConfig?.hostname === 'cscase.com' && (
  //         <a
  //           className="google"
  //           href="/auth/google"
  //           onClick={reachGoal}
  //           data-reachgoal="g_auth"
  //         >
  //           <div className="top"></div>
  //         </a>
  //       )}
  //       <a
  //         className="fb"
  //         href="/auth/fb"
  //         onClick={reachGoal}
  //         data-reachgoal="fb_auth"
  //       />
  //     </div>
  //   ) : (
  //     <>
  //       {getConfig?.hostname !== 'cscase.com' && (
  //         <a
  //           className="advantages-sign-in-vk"
  //           href="/auth/vk"
  //           onClick={reachGoal}
  //           data-reachgoal="vk_auth"
  //         >
  //           <div className="top"></div>
  //           <div className="bot-1"></div>
  //         </a>
  //       )}
  //       <a
  //         className="advantages-sign-in-fb"
  //         href="/auth/fb"
  //         onClick={reachGoal}
  //       >
  //         <div className="top"></div>
  //         <div className="bot-1"></div>
  //       </a>
  //       {getConfig?.hostname === 'cscase.com' && (
  //         <a
  //           className="advantages-sign-in-google"
  //           href="/auth/google"
  //           onClick={reachGoal}
  //           data-reachgoal="g_auth"
  //         >
  //           <div className="top"></div>
  //           <div className="bot"></div>
  //         </a>
  //       )}
  //     </>
  //   )}
  // </div>
};
